import React, {useState, useEffect} from "react";
import {
    Button, DialogContentText, TextField,
} from "@material-ui/core";
import styled from "styled-components";
import {useForm, usePage} from "@inertiajs/inertia-react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import {Form as FinalForm} from "react-final-form";
import {Trans} from "../utils/i18n";
import {Alert, Snackbar} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import {useTranslation} from "react-i18next";
import classNames from "classnames";

const FieldWrapper = styled.div`
    margin-bottom: 10px;
`;

const SelectLabel = styled.div`
    margin-left: 18px;
    margin-top: -8px;
`;

const validateEmail = (emailInputText = "") => {
    var mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return !!emailInputText.match(mailFormat);
};

const PartMissingModal = ({productTitle}) => {
    const {t} = useTranslation();
    const [attachment, setAttachment] = useState("");
    const [errors, setErrors] = useState({
        email: false, confirmEmail: false,
    });

    const [submitting, setSubmitting] = useState(false);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [success, setSuccess] = useState(false);

    const page = usePage();

    const {data, setData, post, processing, transform} = useForm({
        name: "",
        email: "",
        confirmEmail: "",
        summary: `Missing Request for ${productTitle}`,
        description: "",
    });

    const handleClose = () => {
        if (!submitting) {
            setIsDialogOpen(false);
        }
    };

    const handleDialogOpen = () => {
        setData({
            name: "",
            email: "",
            confirmEmail: "",
            summary: `Missing Request for ${productTitle}`,
            description: "",
        });

        setErrors({
            email: false, confirmEmail: false
        });

        setIsDialogOpen(true);
        setSuccess(false);
    };

    const onSubmit = async () => {
        let postData = Object.assign({}, data);

        if (!validateEmail(data.email) || !validateEmail(data.confirmEmail) || data.email !== data.confirmEmail) {
            return false;
        }

        setSubmitting(true);

        const formData = new FormData();
        Object.keys(postData).map((key) => {
            formData.append(key, postData[key]);
        });


        try {
            const response = await fetch(route("jira.create_issue"), {
                method: "POST", headers: {
                    "X-CSRF-Token": page.props.csrfToken,
                }, body: formData,
            });

            const result = await response.json();
            if (result.issueKey) {
                setIsDialogOpen(false);
                setSuccess(true);
                setTimeout(function () {
                    setSuccess(false);
                }, 5000);
            }
            if (result?.status_code === 400 && result?.data?.errorMessage) {
                alert(result?.data?.errorMessage);
            }
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setSubmitting(false);
        }
    };

    useEffect(() => {
        let _errors = {
            email: false, confirmEmail: false
        };

        if (data.email !== "" && !validateEmail(data.email)) {
            _errors.email = t("contactUs.email.invalid");
        } else if (data.email !== "" && data.confirmEmail !== "" && data.email !== data.confirmEmail) {
            _errors.email = t("contactUs.email.notMatch");
        }

        if (data.confirmEmail !== "" && !validateEmail(data.confirmEmail)) {
            _errors.confirmEmail = t("contactUs.confirmEmail.invalid");
        }

        setErrors(_errors);
    }, [data.email, data.confirmEmail]);

    return (<>
        <button
            type="button"
            className={classNames(
                "mt-2 no-underline block w-full font-bold bg-secondary rounded-md text-white px-9 py-3 hover:bg-white hover:text-secondary cursor-pointer shadow-lg transition-all",
                {}
            )}
            onClick={() => handleDialogOpen()}>
            <Trans i18nKey="orderEntry.product.contactUs">Contact Us</Trans>
        </button>
        <Snackbar
            open={success}
            autoHideDuration={6000}
            onClose={() => setSuccess(false)}
        >
            <Alert
                icon={<CheckIcon
                    style={{color: "white"}}
                    fontSize="inherit"
                />}
                onClose={() => setSuccess(false)}
                severity="success"
                sx={{width: "100%"}}
                style={{background: "green", color: "white"}}
            >
                <Trans i18nKey={"contactUs.requestSent"}>
                    Your request has been sent!
                </Trans>
            </Alert>
        </Snackbar>

        <FinalForm onSubmit={onSubmit}>
            {({
                  handleSubmit, values, form, // errors,
                  touched,
              }) => {

                return (<Dialog
                    open={isDialogOpen}
                    onClose={handleClose}
                    fullWidth={true}
                    maxWidth={"md"}
                >
                    <form onSubmit={handleSubmit}>
                        <DialogTitle><Trans
                            i18nKey={"contactUs.partsMissingRequest"}
                        >Parts Missing Email Request</Trans></DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                <Trans
                                    i18nKey={"contactUs.fillTheFieldsBelow"}
                                >
                                    Fill the fields below and press
                                    submit button.
                                </Trans>
                            </DialogContentText>

                            <FieldWrapper>
                                <TextField
                                    required={true}
                                    id="fullname"
                                    name="fullname"
                                    label={<Trans
                                        i18nKey={"contactUs.fullname"}
                                    >
                                        Full Name
                                    </Trans>}
                                    value={data.name}
                                    onChange={(e) => setData("name", e.target.value || "")}
                                    variant="outlined"
                                    type="text"
                                    disabled={submitting}
                                />
                            </FieldWrapper>

                            <FieldWrapper className="w-100 flex justify-between">
                                <div style={{width: "49%"}}>
                                    <TextField
                                        required={true}
                                        id="email"
                                        name="email"
                                        label={<Trans
                                            i18nKey={"contactUs.email"}
                                        >
                                            Email
                                        </Trans>}
                                        value={data.email}
                                        onChange={(e) => setData("email", e.target.value || "")}
                                        variant="outlined"
                                        type="email"
                                        disabled={submitting}
                                        error={errors.email}
                                        helperText={errors.email}
                                    />
                                </div>
                                <div style={{width: "49%"}}>
                                    <TextField
                                        required={true}
                                        id="confirm_email"
                                        name="confirm_email"
                                        label={<Trans
                                            i18nKey={"contactUs.confirm_email"}
                                        >
                                            Confirm Email
                                        </Trans>}
                                        value={data.confirmEmail}
                                        onChange={(e) => setData("confirmEmail", e.target.value || "")}
                                        variant="outlined"
                                        type="email"
                                        disabled={submitting}
                                        error={errors.confirmEmail}
                                        helperText={errors.confirmEmail}
                                    />
                                </div>
                            </FieldWrapper>

                            <FieldWrapper>
                                <TextField
                                    required={true}
                                    id="description"
                                    name="description"
                                    label={<Trans
                                        i18nKey={"contactUs.description"}
                                    >
                                        Description
                                    </Trans>}
                                    value={data.description}
                                    onChange={(e) => setData("description", e.target.value || "")}
                                    multiline
                                    minRows={4}
                                    variant="outlined"
                                    type="text"
                                    disabled={submitting}
                                />
                            </FieldWrapper>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                variant="contained"
                                onClick={handleClose}
                                disabled={submitting}
                            >
                                <Trans i18nKey={"contactUs.cancel"}>
                                    Cancel
                                </Trans>
                            </Button>
                            <Button
                                variant="contained"
                                color={"secondary"}
                                type={"submit"}
                                disabled={submitting}
                            >
                                {submitting ? (<Trans
                                    i18nKey={"contactUs.submitting"}
                                >
                                    Submitting...
                                </Trans>) : (<Trans
                                    i18nKey={"contactUs.submit"}
                                >
                                    Submit
                                </Trans>)}
                            </Button>
                        </DialogActions>
                    </form>
                </Dialog>);
            }}
        </FinalForm>
    </>)
}

export default PartMissingModal;
